module.exports = __webpack_public_path__ + "static/media/t3.cf04db32.png";